import { render, staticRenderFns } from "./PageHorizontalComponent.vue?vue&type=template&id=17c3a48e&scoped=true"
import script from "./PageHorizontalComponent.vue?vue&type=script&lang=js"
export * from "./PageHorizontalComponent.vue?vue&type=script&lang=js"
import style0 from "./PageHorizontalComponent.vue?vue&type=style&index=0&id=17c3a48e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c3a48e",
  null
  
)

export default component.exports